import './SubMatchCodeCell_.css';
import { ICellRendererParams } from 'ag-grid-community';
import { ClaimRow } from 'api/endpoints';
import { CellTextInput } from './CellTextInput';
import { useCallback } from 'react';
export interface SubMatchCodeCellParams extends ICellRendererParams<ClaimRow, any> {
  onUpdateSubMatchCode: (
    data: ClaimRow,
    matchCode: number,
    subMatchCode: number | null,
    cellProps: ICellRendererParams<ClaimRow>,
  ) => unknown;
  selectedRowRef?: string;
  onLostFocus: () => unknown;
  isEditable: boolean;
}

export const SubMatchCodeCell = ({
  isEditable,
  onUpdateSubMatchCode,
  onLostFocus,
  selectedRowRef,
  ...props
}: SubMatchCodeCellParams) => {
  const { data } = props;

  const subMatchCodeUpdate = useCallback((v: string) => {
    return data && data.sourceType
      && onUpdateSubMatchCode(data, data.matchCode, Number(v), props)
  }, [data, onUpdateSubMatchCode, props]);

  const renderInput = isEditable && (data?.sourceType === 'FiledClaim' || data?.sourceType === 'ScheduledClaim') && data.matchCode;

  if (renderInput) {
    return (
      <div className={'submatch-code-cell'}>
        <CellTextInput
          placeholder="Submatch code"
          length={9}
          editDisabled={!!selectedRowRef}
          value={String(data?.subMatchCode ?? '')}
          onChange={(v) => subMatchCodeUpdate(v)}
          onLostFocus={onLostFocus}
        />
      </div>
    );
  }

  return <div className={'submatch-code-cell'}>{data?.subMatchCode ?? '- -'}</div>;
};
